"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KamaSmoother = void 0;
var vpt_abr_common_1 = require("@sky-uk-ott/vpt-abr-common");
var sum_1 = require("../utils/sum");
// KAMA has 3 configurable values, the ones below are the recommended
// values and are also the values used by Quetra in their implementation.
var defaultConfig = {
    efficiencyRatioNumPeriods: 10,
    smoothingConstantFastNumPeriods: 2,
    smoothingConstantSlowNumPeriods: 30,
};
var KamaSmoother = /** @class */ (function () {
    function KamaSmoother(logger, getValueForSmoothing, customConfig) {
        if (customConfig === void 0) { customConfig = defaultConfig; }
        this.getValueForSmoothing = getValueForSmoothing;
        this.samples = [];
        this.logger = logger.withContext('KAMA');
        this.logger.verbose('Received config: ', customConfig);
        this.config = __assign(__assign({}, defaultConfig), customConfig);
        this.logger.info('Using config: ', this.config);
    }
    KamaSmoother.prototype.clear = function () {
        this.samples = [];
        this.lastKama = undefined;
        this.currentEstimate = undefined;
    };
    KamaSmoother.prototype.sample = function (newSample) {
        this.samples = __spreadArray(__spreadArray([], this.samples, true), [newSample], false);
        this.samples = vpt_abr_common_1.ArrayUtils.lastItems(this.samples, this.config.efficiencyRatioNumPeriods + 1, this.logger);
        this.currentEstimate = this.calculateEstimate();
    };
    KamaSmoother.prototype.getValue = function () {
        return this.currentEstimate;
    };
    KamaSmoother.prototype.calculateEstimate = function () {
        if (this.samples.length === 0) {
            return;
        }
        var lastSample = this.getValueForSmoothing(this.samples[this.samples.length - 1]);
        var firstSample = this.getValueForSmoothing(this.samples[0]);
        if (this.samples.length === 1) {
            return lastSample;
        }
        var volatility = this.calculateVolatility();
        var change = Math.abs(lastSample - firstSample);
        var efficiencyRatio = volatility === 0 ? 0 : change / volatility;
        var fastSmoothingConstant = 2 / (this.config.smoothingConstantFastNumPeriods + 1);
        var slowSmoothingConstant = 2 / (this.config.smoothingConstantSlowNumPeriods + 1);
        var smoothingConstant = Math.pow(efficiencyRatio * (fastSmoothingConstant - slowSmoothingConstant) + slowSmoothingConstant, 2);
        var lastKama = this.lastKama || this.calculateSimpleMovingAverage();
        var newKama = lastKama + smoothingConstant * (lastSample - lastKama);
        this.lastKama = newKama;
        return newKama;
    };
    KamaSmoother.prototype.calculateVolatility = function () {
        var _this = this;
        return (0, sum_1.sum)(this.samples, function (sample, index) {
            var nextSample = _this.samples[index + 1];
            if (!nextSample) {
                return 0;
            }
            var diff = Math.abs(_this.getValueForSmoothing(sample) - _this.getValueForSmoothing(nextSample));
            return diff;
        });
    };
    KamaSmoother.prototype.calculateSimpleMovingAverage = function () {
        var _this = this;
        // The simple moving average is used for when we don't have
        // a "previous" KAMA value
        var total = (0, sum_1.sum)(this.samples, function (s) { return _this.getValueForSmoothing(s); });
        var avg = total / this.samples.length;
        return avg;
    };
    return KamaSmoother;
}());
exports.KamaSmoother = KamaSmoother;
